import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  QueryUserMembersResponse,
  UserMemberQuery,
  UserMembersQueryBuilder,
  queryUserMembers as universalQueryUserMembers,
  typedQueryUserMembers as universalTypedQueryUserMembers,
} from './members-usermembers-v1-user-member-user-member.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/members' };

export function queryUserMembers(
  httpClient: HttpClient
): QueryUserMembersSignature {
  return () =>
    universalQueryUserMembers(
      // @ts-ignore
      { httpClient }
    );
}

interface QueryUserMembersSignature {
  /**
   * Creates a query to retrieve a list of user members.
   *
   * The `queryUserMembers()` method builds a query to retrieve a list of user members and returns a [`UserMembersQueryBuilder`](https://dev.wix.com/docs/sdk/backend-modules/members/user-member/user-members-query-builder/ascending) object.
   *
   * The returned object contains the query definition, which is typically used to run the query using the [`find()`](https://dev.wix.com/docs/sdk/backend-modules/members/user-member/user-members-query-builder/find) method.
   *
   * You can refine the query by chaining `UserMembersQueryBuilder` methods onto the query. `UserMembersQueryBuilder` methods enable you to sort, filter, and control the results `queryUserMembers()` returns.
   *
   * `queryUserMembers()` runs with these `UserMembersQueryBuilder` defaults, which you can override:
   *
   * - [`limit(50)`](https://dev.wix.com/docs/sdk/backend-modules/members/user-member/user-members-query-builder/limit)
   */
  (): UserMembersQueryBuilder;
}

export function typedQueryUserMembers(
  httpClient: HttpClient
): TypedQueryUserMembersSignature {
  return (query: UserMemberQuery) =>
    universalTypedQueryUserMembers(
      query,
      // @ts-ignore
      { httpClient }
    );
}

interface TypedQueryUserMembersSignature {
  /** */
  (query: UserMemberQuery): Promise<
    NonNullablePaths<
      QueryUserMembersResponse,
      | `userMembers`
      | `userMembers.${number}.photo._id`
      | `userMembers.${number}.photo.url`
      | `userMembers.${number}.photo.height`
      | `userMembers.${number}.photo.width`
      | `userMembers.${number}.privacyStatus`
      | `userMembers.${number}.status`
      | `userMembers.${number}.activityStatus`,
      5
    >
  >;
}

export {
  ActionEvent,
  ActivityStatusStatus,
  Asset,
  CursorPaging,
  CursorPagingMetadata,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Cursors,
  DeleteContext,
  DeleteStatus,
  DomainEvent,
  DomainEventBodyOneOf,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  Image,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Namespace,
  NamespaceChanged,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  PrivacyStatusStatus,
  QueryUserMembersRequest,
  QueryUserMembersResponse,
  RestoreInfo,
  ServiceProvisioned,
  ServiceRemoved,
  SiteCreated,
  SiteCreatedContext,
  SiteDeleted,
  SiteHardDeleted,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  SitePublished,
  SitePurgedExternally,
  SiteRenamed,
  SiteTransferred,
  SiteUndeleted,
  SiteUnpublished,
  SiteUrlChanged,
  SortOrder,
  Sorting,
  State,
  Status,
  StudioAssigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  StudioUnassigned,
  UserDomainMediaDisabled,
  UserDomainMediaEnabled,
  UserMember,
  UserMemberQuerySpec,
  UserMembersQueryBuilder,
  UserMembersQueryResult,
  WixelAssigned,
  WixelUnassigned,
  utils,
} from './members-usermembers-v1-user-member-user-member.universal.js';
